import React from 'react'
import ibm from '../../assets/images/customer-ibm.png';
import citrix from '../../assets/images/customer-citrix.png';
import sophos from '../../assets/images/customer-sophos.png';
import veeam from '../../assets/images/customer-veeam.png';
import snowflake from '../../assets/images/customer-snowflake.png';
import vertiv from '../../assets/images/customer-vertiv.png';
import intel from '../../assets/images/customer-intel.png';
import lenovo from '../../assets/images/customer-lenovo.png';
import ntt from '../../assets/images/customer-ntt.png';
import kaspersky from '../../assets/images/customer-kaspersky.png';
import schneider from '../../assets/images/customer-schneider.png';
import hpe from '../../assets/images/customer-hpe.png';
import dell from '../../assets/images/customer-dell.png';
import hcl from '../../assets/images/customer-hcl.png';
import nutanix from '../../assets/images/customer-nutanix.png';
import eaton from '../../assets/images/customer-eaton.png';
import netapp from '../../assets/images/customer-netapp.png';
import ctrls from '../../assets/images/customer-ctrls.png';
import adobe from '../../assets/images/customer-adobe.png';
import microsoft from '../../assets/images/customer-microsoft.png';
import acer from '../../assets/images/customer-acer.png';
import samsung from '../../assets/images/customer-samsung.png';
import cisco from '../../assets/images/customer-cisco.png';
import sonicwall from '../../assets/images/customer-sonicwall.png';
import oracle from '../../assets/images/customer-oracle.png';
import symantec from '../../assets/images/customer-symantec.png';
import accenture from '../../assets/images/customer-accenture.png';
import dlink from '../../assets/images/customer-dlink.png';
import sap from '../../assets/images/customer-sap.png';
import aws from '../../assets/images/customer-aws.png';
 const Partners = () => {
  return (
   <>
     <section className="brand">
         <div className="container">
            <h3>Customer</h3>
            <div className="row row-cols-6">
				<div className="col">
					<div className="brand-inner">
						<img src={ibm}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={citrix}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={sophos}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={veeam}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={snowflake}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={vertiv}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={intel}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={lenovo}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={ntt}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={kaspersky}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={schneider}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={hpe}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={dell}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={hcl}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={nutanix}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={eaton}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={netapp}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={ctrls}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={adobe}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={aws}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={microsoft}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={acer}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={samsung}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={cisco}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={sonicwall}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={oracle}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={symantec}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={accenture}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={dlink}/>
					</div>
				</div>
				<div className="col">
					<div className="brand-inner">
						<img src={sap}/>
					</div>
				</div>
				
				
            </div>
         </div>
      </section>
   </>
  )
}
export default Partners